import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {getDSCongKhamDaChiDinh} from 'src/app/modules/phan-he-kham-benh/services/ChiDinhDVService';
import {ORDER_TYPE_ID, RESPONSE_MESSAGE} from 'src/app/modules/utils/Constant';
import {LOAI_BENH_AN} from 'src/app/modules/phan-he-kham-benh/constants/BenhAn';
import {useBenhAnContext} from 'src/app/modules/phan-he-kham-benh/contexts/BenhAnContext';
import DanhSachDichVu from './components/DanhSachDichVu';
import ThongTinPhieu from './components/ThongTinPhieu';
import {columnsDSKhamBenh} from "../../../../../columns/tab-kham-benh/ColumnTabKhamBenh";

const PhieuKhamBenh = () => {
  const {phieuBenhAn} = useBenhAnContext();

  const [data, setData] = useState<any>();

  useEffect(() => {
    if (LOAI_BENH_AN.PHIEU_KHAM_BENH === phieuBenhAn?.displayCode) {
      getDetailPhieu();
    }
  }, [phieuBenhAn?.id, phieuBenhAn?.displayCode]);

  const getDetailPhieu = async () => {
    try {
      let { data } = await getDSCongKhamDaChiDinh({
        orderGroupId: phieuBenhAn?.id,
        type: ORDER_TYPE_ID.CONG_KHAM
      });
      setData({
        ...phieuBenhAn,
        terms: data.data,
      });
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  return (
    <div className="spaces p-10">
      <ThongTinPhieu data={data}/>
      <DanhSachDichVu data={data?.terms} columns={columnsDSKhamBenh}/>
    </div>
  );
};

export default PhieuKhamBenh;
